import { SET_FULFILMENT_TYPE } from 'redux/modules/slot-booking/actions/types';

export const setFulfilmentType = fulfilmentType => ({ type: SET_FULFILMENT_TYPE, fulfilmentType });
